module.exports = __webpack_public_path__ + "img/galeria-agua-dulce-3.b1a8f9ce.jpg";